import { GetEmailQueueBlacklist } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetEmailQueueBlacklist
  extends BaseHttpService<GetEmailQueueBlacklist.Model>
  implements GetEmailQueueBlacklist
{
  async get(params: GetEmailQueueBlacklist.Params): Promise<GetEmailQueueBlacklist.Model> {
    return await this.request('get', {}, params);
  }
}
